import { render, staticRenderFns } from "./revenueByProductPage.vue?vue&type=template&id=0bd6ea2f&scoped=true&"
import script from "./revenueByProductPage.vue?vue&type=script&lang=js&"
export * from "./revenueByProductPage.vue?vue&type=script&lang=js&"
import style0 from "./revenueByProductPage.vue?vue&type=style&index=0&id=0bd6ea2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6ea2f",
  null
  
)

export default component.exports